import { AlertCircle, RotateCw } from "lucide-react";
import EmptyState from "./EmptyState";
import Button from "./Button";

/**
 * "We couldn't..." with what to do and a Retry (docs/design/HANDOFF.md,
 * "Error states"). `onRetry` draws the Retry button; `retrying` shows it busy.
 */
const ErrorState = ({ title = "We couldn't load this", children, onRetry = null, retrying = false, retryLabel = "Retry", className }) => (
  <div role="alert" className={className}>
    <EmptyState
      tone="red"
      icon={<AlertCircle className="h-7 w-7" aria-hidden="true" />}
      title={title}
      action={
        onRetry ? (
          <Button onClick={onRetry} busy={retrying} icon={<RotateCw className="h-4 w-4" aria-hidden="true" />}>
            {retrying ? "Retrying" : retryLabel}
          </Button>
        ) : null
      }
    >
      {children}
    </EmptyState>
  </div>
);

export default ErrorState;
